import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_libpluginf87c1bbc_0d2d65cc from 'nuxt_plugin_libpluginf87c1bbc_0d2d65cc' // Source: ./lib.plugin.f87c1bbc.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_index_719d8f04 from 'nuxt_plugin_index_719d8f04' // Source: ./commonUI/store/index.js (mode: 'all')
import nuxt_plugin_mergelocalestoi18n_4641272c from 'nuxt_plugin_mergelocalestoi18n_4641272c' // Source: ./commonUI/plugins/merge-locales-to-i18n.js (mode: 'all')
import nuxt_plugin_jsonld_a8a6fa46 from 'nuxt_plugin_jsonld_a8a6fa46' // Source: ./commonUI/plugins/jsonld.js (mode: 'all')
import nuxt_plugin_globalcomponents_91d8751e from 'nuxt_plugin_globalcomponents_91d8751e' // Source: ./commonUI/plugins/global-components.js (mode: 'all')
import nuxt_plugin_i18n_967e8706 from 'nuxt_plugin_i18n_967e8706' // Source: ./commonUI/registeredModules/i18n/i18n.js (mode: 'all')
import nuxt_plugin_analytics_ff9c3aa2 from 'nuxt_plugin_analytics_ff9c3aa2' // Source: ./commonUI/registeredModules/analytics/analytics.js (mode: 'all')
import nuxt_plugin_index_47f21709 from 'nuxt_plugin_index_47f21709' // Source: ./listingPagesUi/store/index.js (mode: 'all')
import nuxt_plugin_index_3eb32e1b from 'nuxt_plugin_index_3eb32e1b' // Source: ./homepageUI/store/index.js (mode: 'all')
import nuxt_plugin_index_72747a80 from 'nuxt_plugin_index_72747a80' // Source: ./nuxt-font-loader-strategy/index.js (mode: 'all')
import nuxt_plugin_nuxtenv_001ebd4f from 'nuxt_plugin_nuxtenv_001ebd4f' // Source: ./nuxt-env.js (mode: 'all')
import nuxt_plugin_routerrouterfb61d812_766a1c74 from 'nuxt_plugin_routerrouterfb61d812_766a1c74' // Source: ./router.router.fb61d812.js (mode: 'all')
import nuxt_plugin_repositoryrepository059832d2_43650521 from 'nuxt_plugin_repositoryrepository059832d2_43650521' // Source: ./repository.repository.059832d2.js (mode: 'all')
import nuxt_plugin_authauthclient412cbd3e_5fffbfd7 from 'nuxt_plugin_authauthclient412cbd3e_5fffbfd7' // Source: ./auth.auth.client.412cbd3e.js (mode: 'client')
import nuxt_plugin_authauthserverb233a274_5c9eac5a from 'nuxt_plugin_authauthserverb233a274_5c9eac5a' // Source: ./auth.auth.server.b233a274.js (mode: 'server')
import nuxt_plugin_globalconfigserver_a1fd0426 from 'nuxt_plugin_globalconfigserver_a1fd0426' // Source: ./global-config.server.js (mode: 'server')
import nuxt_plugin_bugsnagclient45f9bcba_6760a25e from 'nuxt_plugin_bugsnagclient45f9bcba_6760a25e' // Source: ./bugsnag.client.45f9bcba.js (mode: 'client')
import nuxt_plugin_portalvue_2f63a5cd from 'nuxt_plugin_portalvue_2f63a5cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_vuenotificationsvuenotificationsclient5a153a82_60b75f8a from 'nuxt_plugin_vuenotificationsvuenotificationsclient5a153a82_60b75f8a' // Source: ./vue-notifications.vue-notifications.client.5a153a82.js (mode: 'client')
import nuxt_plugin_vuenotificationsvuenotificationsserver8062a7ec_3ad89e3a from 'nuxt_plugin_vuenotificationsvuenotificationsserver8062a7ec_3ad89e3a' // Source: ./vue-notifications.vue-notifications.server.8062a7ec.js (mode: 'server')
import nuxt_plugin_vlazyload_d2bada98 from 'nuxt_plugin_vlazyload_d2bada98' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_eventbusplugin531f88da_bd9fb5dc from 'nuxt_plugin_eventbusplugin531f88da_bd9fb5dc' // Source: ./event-bus.plugin.531f88da.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_image_aaba817e from 'nuxt_plugin_image_aaba817e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_forter_301714ee from 'nuxt_plugin_forter_301714ee' // Source: ../plugins/forter.js (mode: 'all')
import nuxt_plugin_dynamicpageviewclient_118f517d from 'nuxt_plugin_dynamicpageviewclient_118f517d' // Source: ../plugins/dynamic-page-view.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"web-ui","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"author","content":"SEPHORA"},{"name":"theme-color","content":"#000"},{"property":"og:image","content":"https:\u002F\u002Fstatic-reg.lximg.com\u002Fassets\u002Fsephora_og_image-34f1169559fdb47662226655a01e2f90dabe8622664f82b7f9b4ed5907237b3d.jpg","id":"og-image","name":"og:image"},{"property":"og:type","content":"website","id":"og-type","name":"og:type"},{"property":"og:site_name","content":"Sephora","id":"og-site-name"},{"property":"al:web:should_fallback","content":"false"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fsessions.bugsnag.com","crossorigin":true}],"__dangerouslyDisableSanitizers":["script"],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_libpluginf87c1bbc_0d2d65cc === 'function') {
    await nuxt_plugin_libpluginf87c1bbc_0d2d65cc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_index_719d8f04 === 'function') {
    await nuxt_plugin_index_719d8f04(app.context, inject)
  }

  if (typeof nuxt_plugin_mergelocalestoi18n_4641272c === 'function') {
    await nuxt_plugin_mergelocalestoi18n_4641272c(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_a8a6fa46 === 'function') {
    await nuxt_plugin_jsonld_a8a6fa46(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91d8751e === 'function') {
    await nuxt_plugin_globalcomponents_91d8751e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_967e8706 === 'function') {
    await nuxt_plugin_i18n_967e8706(app.context, inject)
  }

  if (typeof nuxt_plugin_analytics_ff9c3aa2 === 'function') {
    await nuxt_plugin_analytics_ff9c3aa2(app.context, inject)
  }

  if (typeof nuxt_plugin_index_47f21709 === 'function') {
    await nuxt_plugin_index_47f21709(app.context, inject)
  }

  if (typeof nuxt_plugin_index_3eb32e1b === 'function') {
    await nuxt_plugin_index_3eb32e1b(app.context, inject)
  }

  if (typeof nuxt_plugin_index_72747a80 === 'function') {
    await nuxt_plugin_index_72747a80(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtenv_001ebd4f === 'function') {
    await nuxt_plugin_nuxtenv_001ebd4f(app.context, inject)
  }

  if (typeof nuxt_plugin_routerrouterfb61d812_766a1c74 === 'function') {
    await nuxt_plugin_routerrouterfb61d812_766a1c74(app.context, inject)
  }

  if (typeof nuxt_plugin_repositoryrepository059832d2_43650521 === 'function') {
    await nuxt_plugin_repositoryrepository059832d2_43650521(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authauthclient412cbd3e_5fffbfd7 === 'function') {
    await nuxt_plugin_authauthclient412cbd3e_5fffbfd7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_authauthserverb233a274_5c9eac5a === 'function') {
    await nuxt_plugin_authauthserverb233a274_5c9eac5a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_globalconfigserver_a1fd0426 === 'function') {
    await nuxt_plugin_globalconfigserver_a1fd0426(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnagclient45f9bcba_6760a25e === 'function') {
    await nuxt_plugin_bugsnagclient45f9bcba_6760a25e(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2f63a5cd === 'function') {
    await nuxt_plugin_portalvue_2f63a5cd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuenotificationsvuenotificationsclient5a153a82_60b75f8a === 'function') {
    await nuxt_plugin_vuenotificationsvuenotificationsclient5a153a82_60b75f8a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_vuenotificationsvuenotificationsserver8062a7ec_3ad89e3a === 'function') {
    await nuxt_plugin_vuenotificationsvuenotificationsserver8062a7ec_3ad89e3a(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_d2bada98 === 'function') {
    await nuxt_plugin_vlazyload_d2bada98(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbusplugin531f88da_bd9fb5dc === 'function') {
    await nuxt_plugin_eventbusplugin531f88da_bd9fb5dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_image_aaba817e === 'function') {
    await nuxt_plugin_image_aaba817e(app.context, inject)
  }

  if (typeof nuxt_plugin_forter_301714ee === 'function') {
    await nuxt_plugin_forter_301714ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dynamicpageviewclient_118f517d === 'function') {
    await nuxt_plugin_dynamicpageviewclient_118f517d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
